// import React from 'react';
// import tw from 'twin.macro';
// // import { css } from 'styled-components/macro';
// import { motion } from 'framer-motion';
// import AnimationRevealPage from "../helpers/AnimationRevealPage.js";
// import Headers from "components/headers/light.js";

// const Container = tw.div`p-8 max-w-6xl mx-auto text-gray-800 bg-white rounded-2xl shadow-lg mt-10 mb-10`;
// const Section = tw.div`mt-10`;
// const Title = tw.h1`text-5xl font-extrabold text-center text-indigo-700 mb-6`;
// const Subtitle = tw.h2`text-3xl font-semibold text-indigo-600 mb-2`;
// const Paragraph = tw.p`mb-4 leading-relaxed text-xl text-secondary-900`;
// // const List = tw.ul`list-disc ml-6 mt-2`;


// const fadeIn = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
// };

// const TermsAndRefundPolicy = () => {
//   return (
//     <motion.div initial="hidden" animate="visible" variants={fadeIn}>
//       <Container>
//         <Headers></Headers>
//         <AnimationRevealPage>
//         <Title>Terms of Service</Title>

//         <Paragraph>
//           Welcome to Blake Technologies. These Terms of Service govern your use of our API Dashboard App. By accessing or using our services, you agree to comply with these terms.
//         </Paragraph>

//         <Section>
//           <Subtitle>1. Account Responsibilities</Subtitle>
//           <Paragraph>
//             You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. Please notify us immediately if you suspect any unauthorized use.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>2. Acceptable Use</Subtitle>
//           <Paragraph>
//             You agree not to misuse our services, including but not limited to interfering with network security, reverse engineering our platform, or accessing unauthorized data.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>3. Subscription & Billing</Subtitle>
//           <Paragraph>
//             Subscriptions are billed monthly. You are responsible for all applicable charges incurred through your account. Credits are awarded upon successful billing.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>4. Modifications</Subtitle>
//           <Paragraph>
//             We reserve the right to modify or discontinue any part of our services at any time. We will provide notice when significant changes are made.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>5. Limitation of Liability</Subtitle>
//           <Paragraph>
//             Blake Technologies shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the app or any third-party services.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>6. Termination</Subtitle>
//           <Paragraph>
//             We may suspend or terminate your access if you violate these terms. You may cancel your subscription at any time.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>7. Governing Law</Subtitle>
//           <Paragraph>
//             These terms shall be governed by the laws of Ghana. Any disputes shall be resolved under Ghanaian jurisdiction.
//           </Paragraph>
//         </Section>

//         <Title tw="mt-16">Refund Policy</Title>

//         <Section>
//           <Subtitle>1. Digital Product Nature</Subtitle>
//           <Paragraph>
//             Due to the nature of digital services and usage-based billing, all purchases are considered final. We do not offer refunds for consumed credits.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>2. Subscription Refunds</Subtitle>
//           <Paragraph>
//             Refunds for subscriptions are handled on a case-by-case basis and must be requested within 3 days of the charge. Please contact our support team for eligibility.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>3. Double Charges</Subtitle>
//           <Paragraph>
//             If you were billed more than once for the same service, please reach out and we will promptly issue a correction or refund.
//           </Paragraph>
//         </Section>

//         <Section>
//           <Subtitle>4. Contact Us</Subtitle>
//           <Paragraph>
//             For questions or concerns about refunds and billing, email us at <strong>blakeind72@gmail.com</strong>
//           </Paragraph>
//         </Section>
//         </AnimationRevealPage>
//       </Container>
//     </motion.div>
//   );
// };

// export default TermsAndRefundPolicy;

import React from 'react';
import tw from 'twin.macro';
import { motion } from 'framer-motion';
import AnimationRevealPage from "../helpers/AnimationRevealPage.js";
import Headers from "src/components/headers/light.js";

const Container = tw.div`p-8 max-w-6xl mx-auto text-gray-800 bg-white rounded-2xl shadow-lg mt-10 mb-10`;
const Section = tw.div`mt-10`;
const Title = tw.h1`text-5xl font-extrabold text-center text-indigo-700 mb-6`;
const Subtitle = tw.h2`text-3xl font-semibold text-indigo-600 mb-2`;
const Paragraph = tw.p`mb-4 leading-relaxed text-xl text-secondary-900`;

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const TermsAndRefundPolicy = () => {
  return (
    <motion.div initial="hidden" animate="visible" variants={fadeIn}>
      <Container>
        <Headers />
        <AnimationRevealPage>
          <Title>Terms of Service</Title>

          <Paragraph>
            Welcome to Blake Technologies. These Terms of Service govern your use of our API Dashboard App. By accessing or using our services, you agree to comply with these terms.
          </Paragraph>

          <Section>
            <Subtitle>1. Account Responsibilities</Subtitle>
            <Paragraph>
              You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. Please notify us immediately if you suspect any unauthorized use.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>2. User Consent & Data Responsibility</Subtitle>
            <Paragraph>
              By uploading any facial images or personal data, you confirm that you have obtained appropriate consent from the individuals represented. You assume full responsibility for all data submitted through your account.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>3. Prohibited Uses</Subtitle>
            <Paragraph>
              You may not use our APIs or services to:
            </Paragraph>
            <ul tw="list-disc ml-6 mb-4 text-lg text-secondary-900">
              <li>Upload facial images without consent</li>
              <li>Conduct surveillance or identity profiling</li>
              <li>Violate data protection or biometric privacy laws</li>
              <li>Mislead, defraud, or impersonate individuals or organizations</li>
            </ul>
          </Section>

          <Section>
            <Subtitle>4. Subscription & Billing</Subtitle>
            <Paragraph>
              Subscriptions are billed monthly. You are responsible for all applicable charges incurred through your account. Credits are awarded upon successful billing. Canceling a subscription early will not remove previously granted credits.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>5. Right to Data Deletion</Subtitle>
            <Paragraph>
              If you wish to delete your account or any associated personal data, please contact us. We honor deletion requests in accordance with applicable data protection laws.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>6. Modifications</Subtitle>
            <Paragraph>
              We reserve the right to modify or discontinue any part of our services at any time. We will provide notice when significant changes are made.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>7. Limitation of Liability</Subtitle>
            <Paragraph>
              Blake Technologies shall not be liable for any direct or indirect damages arising from the misuse of our platform, especially involving biometric data. Users are solely accountable for lawful use of our APIs.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>8. Suspension and Audit Rights</Subtitle>
            <Paragraph>
              We reserve the right to audit accounts and suspend access if we detect suspicious, illegal, or non-compliant activity.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>9. Governing Law</Subtitle>
            <Paragraph>
              These terms shall be governed by the laws of Ghana. Any disputes shall be resolved under Ghanaian jurisdiction.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>10. Updates to Terms of Service</Subtitle>
            <Paragraph>
              We reserve the right to change these terms of service at any time. The updated terms will take effect immediately and apply to your use of our services.
            </Paragraph>
          </Section>

          <Title tw="mt-16">Refund Policy</Title>

          <Section>
            <Subtitle>1. Digital Product Nature</Subtitle>
            <Paragraph>
              Due to the nature of digital services and usage-based billing, all purchases are considered final. We do not offer refunds for consumed credits.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>2. Subscription Refunds</Subtitle>
            <Paragraph>
              Refunds for subscriptions are handled on a case-by-case basis and must be requested within 3 days of the charge. Please contact our support team for eligibility.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>3. Double Charges</Subtitle>
            <Paragraph>
              If you were billed more than once for the same service, please reach out and we will promptly issue a correction or refund.
            </Paragraph>
          </Section>

          <Section>
            <Subtitle>4. Contact Us</Subtitle>
            <Paragraph>
              For any questions or concerns about billing, subscriptions, or data usage, email us at <strong>info@blaketechhq.com</strong>
            </Paragraph>
          </Section>
        </AnimationRevealPage>
      </Container>
    </motion.div>
  );
};

export default TermsAndRefundPolicy;
